module.exports = __webpack_public_path__ + "img/baoxian03.82351736.png";